import React from "react"
import styles from "./DeliveryLabel.module.css"

function TableNumber({ number }: {number: number | string}) {
  return number && <span className={styles.deliveryLabel}>Bord {number}</span>
}

export default TableNumber
